"use strict";
import {onFind} from "@elements/init-modules-in-scope";
import {on, addClass, removeClass, findIn, findAllIn, closest, removeAttribute, setAttribute} from "@elements/dom-utils";
import axios from "axios";

export function init () {
    onFind('.js-pricelist', (list) => {

        let loadingElement = findIn('.js-pricelist__loading', list);
        let downloadBtn = findIn('.js-pricelist__download', list);
        let submitted = false;

        //only allow one checkbox list to be checked
        findAllIn('.js-pricelist__checkbox', list).forEach((checkbox) => {
            let id = '';
            on('click', (evt) => {
                id = closest('.js-pricelist__item', evt.target).getAttribute('id');

                findAllIn('.js-pricelist__item', list).forEach((item) => {
                    if(item.getAttribute('id') !== id){
                        findAllIn('.js-pricelist__checkbox', item).forEach((element) => {
                            element.checked = false;
                        });
                    }
                });
            }, checkbox);
        });

        on('submit', (evt) => {

            evt.preventDefault();

            let data = new FormData(evt.target);
            let params = new URLSearchParams(data);
            
            let url = list.getAttribute('data-pricelist-url');

            addClass('visually-hidden', downloadBtn);
            if (loadingElement) {
                removeAttribute('hidden', loadingElement);
            }

            let pendingRequest = axios({method: 'GET', url: url, params: params });
            pendingRequest.then((response) => {
                let result = response.data;
                submitted = true;
                if (result.success) {
                    if (loadingElement) {
                        setAttribute('hidden', true, loadingElement);
                    }
                }
            }).catch(e => {console.warn(e);});
        }, list);

        setInterval(function() {
            let statusUrl = list.getAttribute('data-pricelist-status');
            let pendingRequest = axios({method: 'GET', url: statusUrl});

            pendingRequest.then(response => {
                let result = response.data;
                if(result.inProgress){
                    if (loadingElement) {
                        removeAttribute('hidden', loadingElement);
                    }
                }
                else if(result.generalInProgress){
                    if (loadingElement) {
                        removeAttribute('hidden', loadingElement);
                    }
                }
                else{
                    if(submitted){
                        let link = downloadBtn.getAttribute('href');
                        window.open(window.location.origin + link, '_blank');
                        removeClass('visually-hidden', downloadBtn);
                        submitted = false;
                    }
                    if (loadingElement) {
                        setAttribute('hidden', true, loadingElement);
                    }
                }
            }).catch(e => {console.warn(e);});
        }, 5000);
    });
}
